function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Wrapper, StyledMenuItem, MenuItemInner, StyledMenuList, MenuListWrapper, StyledArrowDown, StyledValueContainer, InputValueText, InputValueTextWrapper, InputField, InputWrapper } from './styles';

function inputComponent(_ref) {
  var inputRef = _ref.inputRef,
      props = _objectWithoutProperties(_ref, ["inputRef"]);

  return /*#__PURE__*/React.createElement(InputWrapper, Object.assign({
    ref: inputRef
  }, props));
}

function Control(_ref2) {
  var isDisabled = _ref2.isDisabled,
      hasValue = _ref2.hasValue,
      innerProps = _ref2.innerProps,
      children = _ref2.children,
      selectProps = _ref2.selectProps,
      innerRef = _ref2.innerRef;
  var menuIsOpen = selectProps.menuIsOpen,
      error = selectProps.error,
      InputProps = selectProps.InputProps;
  return /*#__PURE__*/React.createElement(InputField, Object.assign({
    hasValue: hasValue,
    isDisabled: isDisabled,
    menuIsOpen: menuIsOpen,
    error: error,
    fullWidth: true,
    margin: "dense",
    inputComponent: inputComponent,
    inputProps: _objectSpread({
      inputRef: innerRef,
      children: children
    }, innerProps)
  }, InputProps));
}

var DropdownIndicator = function DropdownIndicator(_ref3) {
  var innerProps = _ref3.innerProps,
      isDisabled = _ref3.isDisabled;
  return /*#__PURE__*/React.createElement(StyledArrowDown, Object.assign({}, innerProps, {
    isDisabled: isDisabled
  }));
};

var IndicatorSeparator = function IndicatorSeparator() {
  return null;
};

var Menu = function Menu(_ref4) {
  var innerProps = _ref4.innerProps,
      children = _ref4.children,
      selectProps = _ref4.selectProps;
  return /*#__PURE__*/React.createElement(MenuListWrapper, innerProps, /*#__PURE__*/React.createElement(StyledMenuList, selectProps, children));
};

var Option = function Option(_ref5) {
  var innerRef = _ref5.innerRef,
      isFocused = _ref5.isFocused,
      innerProps = _ref5.innerProps,
      children = _ref5.children;
  return /*#__PURE__*/React.createElement(StyledMenuItem, Object.assign({
    buttonRef: innerRef,
    selected: isFocused
  }, innerProps), /*#__PURE__*/React.createElement(MenuItemInner, null, children));
};

var SingleValue = function SingleValue(_ref6) {
  var innerProps = _ref6.innerProps,
      isDisabled = _ref6.isDisabled,
      hasValue = _ref6.hasValue,
      children = _ref6.children;
  return /*#__PURE__*/React.createElement(InputValueTextWrapper, Object.assign({}, innerProps, {
    isDisabled: isDisabled,
    hasValue: hasValue
  }), /*#__PURE__*/React.createElement(InputValueText, null, children));
};

var ValueContainer = function ValueContainer(_ref7) {
  var children = _ref7.children;
  return /*#__PURE__*/React.createElement(StyledValueContainer, null, children);
};

var NoOptionsMessage = function NoOptionsMessage(_ref8) {
  var children = _ref8.children;
  return /*#__PURE__*/React.createElement(StyledMenuItem, null, children);
};

var components = {
  Control: Control,
  Menu: Menu,
  Option: Option,
  Placeholder: SingleValue,
  SingleValue: SingleValue,
  DropdownIndicator: DropdownIndicator,
  IndicatorSeparator: IndicatorSeparator,
  NoOptionsMessage: NoOptionsMessage,
  ValueContainer: ValueContainer
};
export var optionPropType = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.string
});

var SelectComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectComponent, _React$Component);

  var _super = _createSuper(SelectComponent);

  function SelectComponent() {
    var _this;

    _classCallCheck(this, SelectComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value, _ref9) {
      var name = _ref9.name;
      var onChange = _this.props.onChange;
      onChange({
        target: {
          value: value,
          name: name
        }
      });
    });

    return _this;
  }

  _createClass(SelectComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          options = _this$props.options,
          disabled = _this$props.disabled,
          placeholder = _this$props.placeholder,
          error = _this$props.error,
          value = _this$props.value,
          isSearchable = _this$props.isSearchable,
          InputProps = _this$props.InputProps,
          name = _this$props.name,
          rest = _objectWithoutProperties(_this$props, ["options", "disabled", "placeholder", "error", "value", "isSearchable", "InputProps", "name"]);

      return /*#__PURE__*/React.createElement(Wrapper, rest, /*#__PURE__*/React.createElement(Select, {
        components: components,
        placeholder: placeholder,
        onChange: this.handleChange,
        options: options,
        isDisabled: disabled,
        error: error,
        maxMenuHeight: 234,
        isSearchable: isSearchable,
        InputProps: InputProps,
        name: name,
        value: value
      }));
    }
  }]);

  return SelectComponent;
}(React.Component);

_defineProperty(SelectComponent, "propTypes", {
  options: PropTypes.arrayOf(optionPropType).isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.bool,
  value: optionPropType,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  isSearchable: PropTypes.bool
});

_defineProperty(SelectComponent, "defaultProps", {
  options: [],
  isSearchable: true,
  value: null
});

export default SelectComponent;